import { render } from "./FindingsSection.vue?vue&type=template&id=6ef84e30&ts=true"
import script from "./FindingsSection.vue?vue&type=script&lang=ts"
export * from "./FindingsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__